import React from "react";
import LoadFinishedGeneral from "components/MainApp/organisms/LoadFinishedGeneral"
import styles from "./AddConfigTagSuccess.module.scss";
import i18n from "i18n";

const AddBusinessNodeSuccess = ({ name, id, boldButtonFunc }) => {

  return (
    <LoadFinishedGeneral
      title={i18n.t("configtag.create.succesfully", { name: name })}
      boldButtonLabel={i18n.t("go.to.list")}
      buttonLabel={i18n.t("create.another.configtag")}
      boldButtonLink={"/admin/config_tags"}
      buttonLink={`/admin/config_tags/add`}
      boldButtonFunc={boldButtonFunc}
    >
      <div className={styles["add-businessnode-success-container"]}>
        <div className={styles["add-businessnode-success-id"]}>{i18n.t("id")} {id}</div>
      </div>
    </LoadFinishedGeneral>
  )

}

export default AddBusinessNodeSuccess;